import GobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'

export function getCruiseExtraFilters(queryParams: URLSearchParams) {
  const cruiseShips = queryParams.getAll('cruiseShips')
  const cabinTypes = queryParams.getAll('cabinTypes')
  const minPrice = queryParams.get('price.min')
  const maxPrice = queryParams.get('price.max')
  const isSpecialOffers = queryParams.get('isSpecialOffers')
  const isLuxExclusivePromotion = queryParams.get('isLuxExclusivePromotion')

  return {
    cruiseShips,
    cabinTypes,
    isSpecialOffers: Boolean(isSpecialOffers) || undefined,
    isLuxExclusivePromotion: Boolean(isLuxExclusivePromotion) || undefined,
    'price.min': minPrice ? parseInt(minPrice) : undefined,
    'price.max': maxPrice ? parseInt(maxPrice) : undefined,
  }
}

export function getCruiseGlobalFilters(globalSearch: GobalSearchState) {
  const {
    searchItem,
    secondarySearchItem,
    cruiseLines,
    flexibleMonths,
    durationMax,
    durationMin,
  } = globalSearch

  return {
    cruiseLines,
    durationMax: durationMax || undefined,
    durationMin: durationMin || undefined,
    destinationId: searchItem?.value,
    destinationName: searchItem?.format.mainText,
    portId: secondarySearchItem?.value,
    portName: secondarySearchItem?.format.mainText,
    departureMonths: flexibleMonths || undefined,
  }
}

export function getCruiseFilters(globalSearch: GobalSearchState, queryParams?: URLSearchParams) {
  const globalFilters = getCruiseGlobalFilters(globalSearch)

  return {
    ...globalFilters,
    ...(queryParams ? getCruiseExtraFilters(queryParams) : {}),
  }
}
